export const projects = [
  {
    title: "Password Generator",
    subtitle: "JavaScript, HTML e CSS",
    description:
      "Nesse projeto, usei JavaScript, HTML e CSS para poder fazer um gerador de senhas",
    image: "./image3.png",
    link: "https://gerador-de-senhas-forte.netlify.app/",
  },
  {
    title: "Onitama",
    subtitle: "Java",
    description:
      "Nesse projeto, tive a oportunidade de desenvolver as regras do jogo Onitama em JAVA",
    image: "./image1.png",
    link: "https://github.com/wgrfernandes/ONITAMA-EP",
  },
  {
    title: "Ping Pong",
    subtitle: "React",
    description: "Aqui eu pude fazer um jogo super legal de ping pong",
    image: "./image2.jpg",
    link: "https://crashed-ping-pong.netlify.app/",
  },
];

export const skills = [
  "JavaScript",
  "Python",
  "HTML",
  "CSS",
  "C",
  "SQL",
  "Java",
  "Kali Linux",
  "OSINT",
  "OWASP",
  "Planejamento de Projetos",
  "Organização de Rotinas",
  "Inglês Avançado (C1)",
  "Espanhol Fluente",
  "Resolução de Problemas",
  "Trabalho em Equipe",
  "Liderança",
  "Escuta ativa",
  "Criatividade",
  "Resiliência",
];



// WEBPACK FOOTER //
// ./src/data.js